<template>
  <div>
    <b-modal
      id="profile-modal"
      ref="modal"
      @hidden="hideProfileModal"
      :size="modalSize"
      :body-class="dynamicBodyClass"
      :hide-header="!hasJdUtilizationAuthority"
    >
      <template v-slot:modal-header>
        <!-- <div class="modal-header"> -->
        <!-- <h5 class="modal-title">プロフィール</h5>
        <button
          type="button"
          class="close"
          @click="hideProfileModal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button> -->
        <button
          v-if="hasJdUtilizationAuthority"
          class="overflow-button"
          id="jd-button"
          @click="toggleJdSection"
        >
        {{ jdSectionText }}
        </button>
      </template>

      <template v-slot:default>
        <Loader v-show="!profileLoaded" />
        <button
          v-if="!hasJdUtilizationAuthority && !showJdSection"
          type="button"
          class="close"
          @click="hideProfileModal"
          aria-label="Close"
          style="position: absolute; right: 25px; top: 15px; z-index: 1050; font-size: 30px; opacity: 0.5;"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div :class="profileAttributes.row">
          <div :class="profileAttributes.col" class="p-0">
            <div class="profile" :class="profileAttributes.class">
              <Profile
                  :applicant-id="id"
                  :applicantIndex="applicantIndex"
                  :isAdmin="isAdmin"
                  :isReviewer="isReviewer"
                  :isPreview="isPreview"
                  :isMaxHeight="true"
                  :canGoPrevious="canGoPrevious"
                  :canGoNext="canGoNext"
                  @statusChanged="statusChanged"
                  @previous="previous"
                  @next="next"
                  @open-contact="openContactModal"
                >
                </Profile>
            </div>
          </div>
          <template v-if="hasJdUtilizationAuthority && showJdSection">
            <div
              class="col-md-6 p-0"
              v-if="profileView === 'jdList'"
            >
              <JDList :applicantId="id" @closeModal="hideProfileModal" />
            </div>
            <div
              class="col-md-6 p-0"
              v-else-if="profileView === 'jdInfo'"
            >
              <JDInfo :applicantId="id" @closeModal="hideProfileModal" />
            </div>
          </template>
        </div>
      </template>
      <template v-slot:modal-footer :style="{ justifyContent: 'center' }">
        <!-- Navigation buttons moved to BasicInfo card -->
        <!-- <div class="profile-toggle-container">
          <div class="toggle-content d-flex" style="width: 85px; justify-content: space-between;">
            <button
              v-show="!(currentPage === 1 && index === 0)"
              class="btn btn-arw btn-plain"
              @click="previous"
              style="min-width: 40px;"
            >
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
            </button>
            <div v-show="currentPage === 1 && index === 0" style="width: 40px;"></div>
            <button
              v-show="rowNumber !== applicantsCount.total"
              class="btn btn-arw btn-plain"
              style="min-width: 40px;"
              @click="next"
            >
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
            <div v-show="rowNumber === applicantsCount.total" style="width: 40px;"></div>
          </div>
        </div> -->


        <!-- Action buttons SECOND -->
        <div class="profile-actions-container w-360 d-flex" style="gap: 40px;">

        </div>

        <!-- Spaces THIRD -->
        <div
          v-if="hasJdUtilizationAuthority"
          class="space"
          :style="showJdSection ? 'width: 40px;' : 'display: none'"
        ></div>

    </template>

    </b-modal>
    <ScoutConfirmation
      ref="scoutConfirmation"
      :applicantJD="applicantJD"
      @scout-confirmed="scoutApplicant"
    />
    <ReviewListPopup
      ref="reviewListPopup"
      :applicant="applicant"
      :showReviewListModal="showReviewListModal"
      :fromPopup="true"
      @hideModal="hideReviewList"
      @statusChanged="statusChanged"
    />

    <ConfirmationPopup
      ref="confirmationPopUp"
      :modalText="detailsText"
      :buttonText="buttonText"
      @submit="processSubmission"
      @cancel="hideConfirmationModal"
      v-if="openConfirmationPopup"
    />

    <IndividualContactModal
      v-if="showContactModal"
      :applicant_id="id"
      :applicantIndex="index"
      contactListType="applicant"
      @hidden="onContactModalHidden"
    />
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Profile from './Profile.vue';
import JDInfo from './profileJd/JDInfo.vue';
import JDList from './profileJd/JDList.vue';
import ScoutButton from '../../ScoutButton.vue';
import ReviewListPopup from '../../ReviewListPopup.vue';
import mutations from '@/config/mutations';
import ApiService from '../../../../service/apiService';
import Api from '../../../../config/api';
import ConfirmationPopup from './ConfirmationPopup.vue';
import Loader from '../../../utils/Loader.vue';
import ScoutConfirmation from './profileJd/ScoutConfirmation.vue';
import IndividualContactModal from '@/components/dashboard/contacts/IndividualContactModal.vue';

export default {
  name: 'ProfileModal',
  props: [
    'applicantId',
    'showProfileModal',
    'applicantIndex',
    'isFavorite',
    'isInterview',
    'applicantdata',
    'isPreview',
    'isPendingReview'
  ],
  components: {
    Profile,
    // JobDescription,
    JDInfo,
    JDList,
    ScoutButton,
    ReviewListPopup,
    ConfirmationPopup,
    Loader,
    ScoutConfirmation,
    IndividualContactModal,
  },
  data() {
    return {
      id: this.applicantId,
      index: this.applicantIndex,
      showModal: this.showProfileModal,
      isProfileLoaded: false,
      showReviewListModal: false,
      option: '',
      openConfirmationPopup: false,
      isLoading: false,
      showContactModal: false,
      shouldRestoreAfterContact: false,
    };
  },
  mounted() {
    if (this.getFirstProfileModalOpen && this.applicantIndex === 0) {
      this.showModal = true;
    }
    if (
      this.getLastProfileModalOpen &&
      this.applicantIndex + 1 === this.applicantsCount.to / this.currentPage
    ) {
      this.showModal = true;
    }
    
    // Load the saved JD section state from sessionStorage
    this.loadJdSectionState();
  },
  
  created() {
    // Also load the state when component is created
    this.loadJdSectionState();
  },
  computed: {
    ...mapState({
      applicant: ({ applicant }) => applicant.profile,
      applicants: ({ applicant }) => applicant.applicants,
      currentPageApplicants: ({ applicant }) => applicant.currentPageApplicants,
      applicantJD: ({ applicant }) => applicant.applicantJD,
      scoutedJD: ({ applicant }) => applicant.scoutedJD,
      profileView: ({ applicant }) => applicant.profileView,
      profileLoaded: ({ applicant }) => applicant.profileLoaded,
    }),
    ...mapGetters({
      applicantsCount: 'getApplicantCounts',
      currentPage: 'getPage',
      getFirstProfileModalOpen: 'getFirstProfileModalOpen',
      getLastProfileModalOpen: 'getLastProfileModalOpen',
      user: 'getCurrentUser',
      isAdmin: 'currentUserIsAdmin',
      isReviewer: 'isCreateReviewUser',
      showJdSection: 'getJdSectionState',
    }),
    jdSectionText() {
      if(this.showJdSection) {
        return '×求人表示を閉じる'
      } else  {
        return '求人表示を開く'
      }
    },
    showJdScreen() {
      return this.isJobseekerMatched || !!this.profileView;
    },
    disableJudgementBtn() {
      if (this.isPreview || this.isPendingReview) {
        return this.applicant.status === '未確認';
      }
      return false; // default if neither condition applies
    },
    assignedToList() {
      if (this.isPendingReview && this.applicant.status !== '未確認') {
        return false;
      } else if (this.isPendingReview && this.applicant.status == '未確認') {
        return true;
      }
      return (
        this.applicant.new_status == '確認依頼中' ||
        this.applicant.new_status == '確認中'
      );
    },
    judgementText() {
      // preview
      // if (this.isPreview) return '対象から除外';

      // pending review
      if (this.isPendingReview || this.isPreview) {
        const map = {
          '未確認': '対象から除外済',
        };
        return map[this.applicant.status] || '対象から除外';
      }

      // default
      return '部門に確認依頼';
    },
    judgementRequested() {
      if(this.isPendingReview || this.isPreview) {
        if(this.applicant.status === '未確認') {
          return 'gray-button';
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    // showJudgementButton() {
    //   const { status, new_status } = this.applicant;
    //   const reviewStatuses = ['確認中', '確認依頼中'];
      
    //   // Hide if from preview screen and status is not in review
    //   // if (this.isPreview) {
    //   //   const isInReview = reviewStatuses.includes(status) || reviewStatuses.includes(new_status);
    //   //   if (!isInReview) {
    //   //     return false;
    //   //   }
    //   //     if (new_status === 'スカウト対象' || status === 'コンタクト済み') {
    //   //     return false;
    //   //   }
    //   // }
      
    //   // Hide for specific statuses
    //   // if (new_status === 'スカウト対象' || status === 'コンタクト済み') {
    //   //   return false;
    //   // }
      
    //   return true;
    // },
    detailsText() {
      if (this.option == 'list') {
        return 'スカウトする求人が選択されていません <br/> このまま判定を依頼しますか？';
      } else {
        return 'スカウトする求人が選択されていません<br/> このままスカウト候補へ追加しますか？';
      }
    },
    buttonText() {
      if (this.option == 'list') {
        return '判定を依頼する';
      } else {
        return 'スカウト候補へ追加';
      }
    },
    profileAttributes() {
      if (this.showJdSection && this.hasJdUtilizationAuthority) {
        return {
          row: 'row',
          col: 'col-md-6',
          class: 'profileClass',
        };
      } else {
        return {
          row: '',
          col: '',
          class: '',
        };
      }
    },
    // showJdButton(){
    //   return this.applicantJD === null;
    // },
    rowNumber() {
      return this.applicantsCount.from + this.index;
    },
    canGoPrevious() {
      return !(this.currentPage === 1 && this.index === 0);
    },
    canGoNext() {
      return this.rowNumber < this.applicantsCount.total;
    },
    headerClass() {
      if (this.isPendingReview) {
        return 'margin-bottom:5px;margin-right:90px';
      } else {
        return 'margin-bottom:5px';
      }
    },
    hideHeader() {
      if (!this.hasJdUtilizationAuthority) {
        return false;
      }
      return this.showJdScreen;
    },
    defaultModal() {
      if (!this.hasJdUtilizationAuthority) {
        return true;
      }
      return !this.isJobseekerMatched && !this.profileView;
    },
    isJobseekerMatched() {
      if (!this.applicantJD) {
        return false;
      } else {
        return true;
      }
    },
    modalSize() {
      if (!this.hasJdUtilizationAuthority || !this.showJdSection) {
        return 'lg';
      }
      return 'xl';
    },
    dynamicBodyClass() {
      if (this.showJdSection && this.hasJdUtilizationAuthority) {
        return 'fullProfileModal';
      } else {
        return 'profileModal';
      }
    },
    hasJdUtilizationAuthority() {
      return (this.user && this.user.jdUtilizationAuthority) || false;
    },
  },
  methods: {
    ...mapMutations({
      setPage: 'setPage',
      setProfileModalState: 'setProfileModalState',
      clearJDOnToggle: 'clearJDOnToggle',
      clearJDDatas: 'clearJDDatas',
      setProfile: mutations.applicant.SET_PROFILE,
      setProfileView: 'setProfileView',
      clearProfileJDDatas: 'profileJd/clearProfileJDDatas',
      setApplicantStatus: 'setApplicantStatus',
      setApplicantMemo: 'setApplicantMemo',
      mutateApplicantsAfterStatus: 'mutateApplicantsAfterStatus',
      setApplicants: mutations.applicant.SET_APPLICANTS,
      removeApplicantFromTempList: 'removeApplicantFromTempList',
      setReloadApplicants: 'setReloadApplicants',
    }),
    ...mapActions({
      setReadStatus: 'setReadStatus',
      toggleJdSection: 'toggleJdSection',
      loadJdSectionState: 'loadJdSectionState',
    }),
    // loadJdSectionState() {
    //   const savedState = sessionStorage.getItem('showJdSection');
    //   if (savedState !== null) {
    //     this.showJdSection = savedState === 'true';
    //     console.log('Loaded JD section state from sessionStorage:', this.showJdSection);
    //   }
    // },
    
    // toggleJdSection() {
    //   this.showJdSection = !this.showJdSection;
    //   // Store the state in sessionStorage to persist throughout the session
    //   sessionStorage.setItem('showJdSection', this.showJdSection.toString());
    //   console.log('Saved JD section state to sessionStorage:', this.showJdSection);
    // },
    async processSubmission() {
      this.openConfirmationPopup = false;
      if (this.option == 'list') {
        this.requestJudgement();
      } else {
        await this.scoutApplicant();
      }
    },
    async scoutApplicant(scoutType = null) {
      try {
        const requestData = {
          status: 'スカウト対象',
          isNewPanel: true,
        };
        
        // Add scoutType if provided
        if (scoutType) {
          requestData.scoutType = scoutType;
          // Send only jd_url and job_title from applicantJD using destructuring
          if (this.applicantJD) {
            const { jd_url, job_title } = this.applicantJD;
            requestData.applicantJD = { jd_url, job_title };
          }
        }
        const { data } = await ApiService.put(
          Api.endpoints.CLIENT_STATUS_CHANGE(this.applicant.id),
          requestData
        );
        this.setApplicantStatus({
          status: 'スカウト対象',
          new_status: 'スカウト対象',
        });
        this.setProfile({
          ...this.applicant,
          memo: data.data.memo,
        });
        this.removeApplicantFromTempList(data.data);
      } catch (error) {
        console.log(error);
        this.parseErrorResponse(error.response);
      }
    },
    statusChanged(data) {
      // data contains the full applicant object from API response
      // Pass the full object to the mutation which will handle both fields
      this.setApplicantStatus(data);
    },
    hideReviewList() {
      this.showReviewListModal = false;
    },
    hideConfirmationModal() {
      this.openConfirmationPopup = false;
      // this.$refs.confirmationModal.close();
    },

    openScoutForm(option) {
      this.$refs.scoutConfirmation.show();
    },
    async checkJdAssigned(option) {
      if (option == 'list' && this.isPendingReview) {
        this.requestJudgement();
        return;
      } else {
        if (option == 'list') {
          this.requestJudgement();
        } else {
          await this.scoutApplicant();
        }
      }
    },
    requestJudgement() {
      if (this.isPreview) {
        return this.removeFromReviewList();
      }

      if (this.isReviewer && !this.isPendingReview) {
        this.showReviewListModal = true;
        return;
      }

      this.removeFromReviewList();
    },
    removeFromReviewList() {
      this.isLoading = true;
      ApiService.put(Api.endpoints.REMOVE_FROM_REVIEW_LIST(this.applicant.id))
        .then(({ data }) => {
          // this.setReloadApplicants(true);

          this.setProfile({
            ...this.applicant,
            status: data.data.status,
            new_status: data.data.new_status,
            scout_jobs: this.applicant.scout_jobs,
          });
          this.removeApplicantFromTempList(data.data);
        })
        .catch((error) => console.log(error))
        .then(() => {
          this.isLoading = false;
        });
    },
    showJdListScreen() {
      this.setProfileView({ view: 'jdList', userBasedMatching: false });
    },
    openContactModal() {
      this.shouldRestoreAfterContact = true;
      this.$bvModal.hide('profile-modal');
      this.showContactModal = true;
    },
    hideProfileModal() {
      this.showModal = false;
      if (!this.shouldRestoreAfterContact) {
        this.clearModal();
      }
      this.shouldRestoreAfterContact = false;
      this.$emit('hideModal');
      if (this.currentPageApplicants.length !== this.applicants.length) {
        this.setReloadApplicants(true);
      }
    },
    onContactModalHidden() {
      this.showContactModal = false;
      this.showModal = true;
    },
    previous() {
      const index = this.index - 1;
      if (index === -1 && this.currentPage !== 1) {
        this.setPage({
          page: this.currentPage - 1,
          FirstProfileModalOpen: false,
          LastProfileModalOpen: true,
        });
      }
      if (this.applicants[index] !== undefined) {
        this.changeApplicant(index);
      }
      this.clearJDDatas('jdInfo');
      this.clearProfileJDDatas();
    },
    next() {
      const index = this.index + 1;
      if (index * this.currentPage === this.applicantsCount.to) {
        this.setPage({
          page: this.currentPage + 1,
          FirstProfileModalOpen: true,
          LastProfileModalOpen: false,
        });
      } else if (this.applicants[index] !== undefined) {
        this.changeApplicant(index);
      }
      this.clearJDDatas('jdInfo');
      this.clearProfileJDDatas();
    },
    changeApplicant(index) {
      this.id = this.applicants[index].id;
      this.index = index;
      this.isFavorited = this.applicants[index].isFavorite;
      this.isInterviewed = this.applicants[index].isInterview;
    },
    clearModal() {
      this.id = this.applicantId;
      this.index = this.applicantIndex;
    },
  },
  watch: {
    applicantIndex(value) {
      this.index = value;
    },
    showProfileModal(value) {
      this.showModal = value;
    },
    showModal(value) {
      if (value) {
        return this.$refs.modal.show();
      }
      return this.$refs.modal.hide();
    },
    profileLoaded(value) {
      if (value) {
        if (this.scoutedJD && this.applicantJD) {
          this.setProfileView({
            view: 'jdInfo',
            individualJD: this.scoutedJD,
            applicantJD: this.applicantJD,
            userBasedMatching: false,
          });
        } else if (this.scoutedJD) {
          this.setProfileView({
            view: 'jdInfo',
            individualJD: this.scoutedJD,
            userBasedMatching: false,
          });
        } else if (this.applicantJD) {
          this.setProfileView({
            view: 'jdList',
            individualJD: this.applicantJD,
            applicantJD: this.applicantJD,
            userBasedMatching: false,
          });
        } else {
          this.setProfileView({
            view: 'jdList',
            userBasedMatching: false,
          });
        }

        // Optional: if you still want to conditionally show the JD button
        // this.showJdButton = value && !this.applicantJD;
      }
    },
    // async handleScoutConfirmed(scoutData) {
    //   console.log('Scout confirmation received:', scoutData);
    //   try {
    //     // Call the existing scoutApplicant method
    //     await this.scoutApplicant(scoutData.scoutType);
        
    //     // Emit the data to parent if needed
    //     this.$emit('scout-confirmed', scoutData);
    //   } catch (error) {
    //     console.error('Error in scout confirmation:', error);
    //   }
    // },
  },
};
</script>

<style scoped>
.fa-chevron-right,
.fa-chevron-left {
  font-size: 1.5rem !important;
}
.p-0 {
  padding: 0px !important;
}
.buttons-align-right {
  margin-right: 80px;
}

.w-360 {
  width: 450px;
}

.request-judgment {
  /* height: 42px !important; */
  background-color: #b7d2f2 !important;
  border-color: #b7d2f2 !important;
  color: #000 !important;
  font-size: 15px;
  font-weight: bold;
}

.request-judgment.gray-button {
  background-color: #b3b3b3 !important;
  border-color: #b3b3b3 !important;
  color: #ffffff !important;
}

.gray-button {
  background-color: #b3b3b3 !important;
  border-color: #b3b3b3 !important;
  color: #3c3c3c !important;
}
.profile-close-button {
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  /* border-radius: 50%; */
  background-color: #ffffff;
  color: #333;
  transition: background-color 0.2s;
}
>>> .scout-button {
  margin-bottom: 0px !important;
}

/*CSS form other Scss*/
/deep/ .modal-xl .modal-footer {
  justify-content: center !important;
  gap: 200px;
}

/deep/ .modal-footer {
  height: 40px !important;
  gap: 30px;
  justify-content: center !important;
  border-top: none !important;
}

/deep/ .modal-header {
  padding: 0px !important;
}

/deep/ .profileModal {
  padding: 3px 0px 4px 0px;
  height: 84vh;
  overflow: hidden auto;
}

.profileClass {
  height: 83vh;
  overflow: auto hidden;
}

/deep/ .fullProfileModal {
  padding: 0px;
  height: 84vh;
  display: flex;
  flex-direction: column;
}

/* Container for the split view */
.row {
  height: 84vh;
  margin: 0;
  flex: 1;
}

/* Columns in split view */
.col-md-6 {
  height: 100%;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
}

/* Profile and JD containers */
.profile,
.jd-container {
  flex: 1;
  overflow: auto;
}

/* Add styles for the profile content container */
.profile {
  height: 100%;
}

/* Ensure the row takes full height when in split view */
.row {
  height: 100%;
}

/* Ensure columns take full height */
.col-md-6 {
  height: 100%;
}

/deep/.overflow-button {
  position: absolute;
  top: 50%; /* Adjust as necessary */
  right: -50px; /* Adjust this value to place the button outside the modal */
  height: 376px;
  width: 55px;
  transform: translateY(-50%);
  z-index: 1055; /* Ensure it is above the modal */
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border: none;
  border-left: 2px solid #036d6c;
  padding: 20px;
  cursor: pointer;
}

.profile-header {
  padding: 2px;
  margin-top: 10px;
  background-color: #036d6c;
}

.profile-header p {
  font-size: 22px;
  color: #fff;
  font-weight: bold;
  padding: 10px;
  margin: auto;
}

.button-placeholder {
  background: transparent;
  border: none;
  visibility: hidden;
}

.actions-placeholder,
.actions-content,
.toggle-placeholder,
.toggle-content {
  display: flex;
  align-items: center;
}
</style>
